import { render } from "./RegistrationModal.vue?vue&type=template&id=59ac4684&scoped=true"
import script from "./RegistrationModal.vue?vue&type=script&lang=js"
export * from "./RegistrationModal.vue?vue&type=script&lang=js"

import "@/Common/Styles/commonModal.scss?vue&type=style&index=0&id=59ac4684&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ac4684"]])

export default __exports__